/* eslint-disable */
import convertList from '../convertList';
import searchUtils from './utils/searchUtils';
import QQFriend from './QQFriend';
import customeBase from './customeBase';
import filters from '../filters';
import sign from '../sign';
import cloudPhoneBook from './cloudPhoneBook';
import colleague from './colleague';
import companyWeChatOrg from './companyWeChatOrg';
import GQQFriend from './GQQFriend';

const funcMap = {
    searchColleague: colleague,
    searchCloudPhoneBook: cloudPhoneBook
};

function generateNormalSearch(method, maps) {
    return (params, config) => {
        const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};

        if (params.ajax) {
            return new Promise((resolve, reject) => {
                try {
                    funcMap[method](params).then(res => {
                        resolve(res);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        // return searchUtils.getNormalSearchData(method, params, maps);
        return new Promise((resolve, reject) => {
            params.searchField = ["showName", "nickName", "remarkName", "account"];
            params.searchScope = ["people", "troop", "discuss"];
            searchUtils
                .getNormalSearchData(method, params)
                .then(list => {
                    let newList = [];
                    let hidden = null;
                    let filter = null;
                    try {
                        hidden = selfConfig.hidden ? new Set(selfConfig.hidden) : null;
                    } catch (err) {
                        // no code
                    }
                    try {
                        filter = selfConfig.filter ? new Set(selfConfig.filter) : null;
                    } catch (err) {
                        // no code
                    }
                    newList = filters.filterTroopList(list, selfConfig);
                    console.log(`generateNormalSearch ${method}`);
                    console.log(JSON.stringify(list));
                    newList = convertList(newList, maps);
                    // 为单向关系链的联系人数据打标记
                    if (config.base.field === 'recent') {
                        newList = sign.oneWayRelationshipChain(list, 'recent', selfConfig);
                        if (hidden && hidden.has('exttmp')) {
                            newList = newList.filter(item => {
                                return !(item.userInfo && item.userInfo.sessionType === 'exttmp');
                            });
                        }

                        // 白名单，过滤出需要展示的内容
                        if (filter) {
                            newList = newList.filter(item => {
                                return filter.has(item.metaSourceType);
                            });

                            if (filter.has('people') && !filter.has('troop') && !filter.has('discuss')) {
                                filters.setKfuinTypeInList(newList).then(filterNewList => {
                                    resolve(filterNewList);
                                });
                            }
                        }
                    }
                    resolve({
                        list: newList
                    });
                })
                .catch(err => {
                    console.log(err);
                    reject(err);
                });
        });
    };
}

function generateTroopSearch(method) {
    return (params, config) => {
        const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
        return new Promise((resolve, reject) => {
            searchUtils
                .getNormalSearchData(method, params)
                .then(list => {
                    let newList = [];
                    if (`${selfConfig.filter}`.indexOf('1') > -1) {
                        list.forEach(item => {
                            if (`${item.isColleague}` !== '1' && `${item.isPrivacy}` !== '1') {
                                newList.push(item);
                            }
                        });
                    } else {
                        newList = list || [];
                    }
                    newList = filters.filterTroopList(newList, selfConfig, 'group');
                    // console.log(`generateTroopSearch ${method}`);
                    // console.log(JSON.stringify(list));
                    resolve({
                        list: convertList(newList)
                    });
                })
                .catch(err => {
                    reject(err);
                });
        });
    };
}

// 同事搜索
function generateColleagueSearch(params, config) {
    let isBigOrgApi = false;
    try {
        isBigOrgApi = config.extendConfig.colleague.isBigOrgApi
    } catch (error) { }
    if (isBigOrgApi) {
        // 如果是大组架
        return new Promise((resolve, reject) => {
            let reqParams = {
                pageSize: (params.pageInfo && params.pageInfo.size) || 50,
                page: params.pageInfo.index,
                keyword: params.name,
                visable: {
                    // filter_disabled: true
                },
            }
            console.log(`[JSAPI][searchOrgStaff][REQ]`, reqParams)
            qdp.searchOrgStaff({
                ...reqParams,
                success: (res) => {
                    let list = [];
                    try {

                        console.log(`[JSAPI][searchOrgStaff][RSP]`, res);
                        // uin: '12312312', // 人员的uin
                        // name: '多人聊天成员1', // 人员名字
                        // face: 'https://a.b.c/d.png', // 人员头像 移动端没有头像不提供
                        list = res.data.staffs.map(x => {
                            return {
                                uin: x.kfext,
                                name: x.name,
                                face: '',
                                colleagueInfo: {
                                    account: x.account, // 账户名称
                                }
                            }
                        }) || [];
                    } catch (err) {
                        // no code
                    }
                    let resParams = {
                        index: res.data.page + 1,
                        end: list.length === 0
                    }

                    resolve({
                        list: convertList(list),
                        params: resParams
                    });
                },
                fail: (err) => {
                    reject(err);
                },
            })
        })
    }
    return generateNormalSearch('searchColleague')(params, config)
}

export default {
    QQFriend,
    colleague: generateColleagueSearch,
    troopMember: generateNormalSearch('searchTroopMember', {
        groupId: 'troopId'
    }),
    troop: generateTroopSearch('searchTroop'),
    discussMember: generateNormalSearch('searchDiscussMember', {
        groupId: 'troopId'
    }),
    discuss: generateNormalSearch('searchDiscuss'),
    recent: generateNormalSearch('searchRecent'),
    customer: generateNormalSearch('searchCustomer'),
    cloudPhoneBook: generateNormalSearch('searchCloudPhoneBook'),
    confGruop: generateNormalSearch('searchConfGruop'),
    confGroupMemeber: generateNormalSearch('searchConfGroupMemeber', {
        groupId: 'troopId'
    }),
    groupChat: generateNormalSearch('searchGroupChat'),
    groupChatMember: generateNormalSearch('searchGroupChatMember', {
        groupId: 'troopId'
    }),
    customeBase,
    groupAssistant: generateNormalSearch('searchGroupAssistant'),
    companyWeChatOrg,
    GQQFriend,
    Gtroop: generateTroopSearch('searchTroop')
};
